import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';
import CreateModal from '../_Shared/CreateModal';
import AppContent from '../_Shared/Layout/AppContent';

const defaultChannel = { name: '' }
const uuidv4 = require('uuid/v4');

class ChannelList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showCreateModal: false,
            channel: defaultChannel,
            anchorEl: null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showCreateModal } = this.state;
        this.setState({ showCreateModal: !showCreateModal, channel: defaultChannel });
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { channel: Object.assign({}, prevState.channel, { [name]: value }) }
        });
    }

    selectElement = channel => {
        this.setState({ channel });
    }

    createChannel = e => {
        const { onChannelAdded } = this.props;
        const { channel } = this.state;
        onChannelAdded(Object.assign({}, channel, { id: uuidv4().replace(/-/g, '') }));
        this.setState({ showCreateModal: false });
    }

    deleteChannel = event => {
        const { onChannelRemoved } = this.props;
        const { channel } = this.state;
        onChannelRemoved(channel);
        this.setState({ channel: defaultChannel, anchorEl: null });
    }

    render() {
        const { channels, onEdit, loading } = this.props;
        const { showCreateModal, channel, anchorEl } = this.state;
        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Channels" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                channels &&
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} rows={channels}
                    toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={() => onEdit(`/data-classifications/channels/${channel.id}/manage/settings`, channel)}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteChannel}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create Channel" open={showCreateModal} closeHandler={this.toggleCreateModal} saveHandler={this.createChannel}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField autoFocus value={channel.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Channel Name" type="text" fullWidth />
                    </Grid>
                </Grid>
            </CreateModal>
        </AppContent>)
    }
}

ChannelList.propTypes = {
    channels: PropTypes.array.isRequired,
};

export default ChannelList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Channels/ChannelList.js